import { render, staticRenderFns } from "./capital-detail.vue?vue&type=template&id=e6acd0da&scoped=true&"
import script from "./capital-detail.vue?vue&type=script&lang=js&"
export * from "./capital-detail.vue?vue&type=script&lang=js&"
import style0 from "./capital-detail.vue?vue&type=style&index=0&id=e6acd0da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6acd0da",
  null
  
)

export default component.exports